import React from 'react';
import { getI18NMessage } from 'I18N/I18NHelper';
import {closeOutlookSettings } from 'js/app/actions/AppActions';
import Checkbox from '@mui/material/Checkbox';
import CustomScrollbar from 'js/common/components/CustomScrollbar';
import CryptoJS from 'crypto-js'
import { GLOBAL_CONSTANTS, APP_URL_CONSTANTS } from 'js/common/constants/GlobalConstants';
import AppHelper from 'js/app/AppHelper';
import properties from 'properties';
import { showMessage } from 'js/modules/message/actions/MessageActions';
import { BOARD_MESSAGE_CONSTANT } from 'js/modules/message/constants/MessageConstants';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import JSZipUtils from 'jszip-utils';
import Button from '@mui/material/Button';
import AppUtil from 'js/utils/AppUtil';

class OutlookConfigView extends React.Component {
	constructor(props) {
		super(props);

        this.state = {
            selectAll: false,
            currentPrj: false,
            otherPrj: false,
            expandCollapseStatus:"otherPrj"
        };
        this.renderCheckbox = this.renderCheckbox.bind(this);
    }
    
    componentDidMount() {
        this.props.getWorkRequestListing();
    }

    renderCheckbox (data, index, action) {
        const w_status = this.state.expandCollapseStatus;
        return (
            <span key= {index}>
                {action !== "noExpandIcon" &&
                    <span className={`expand-collapse ${ w_status.indexOf(data.id) > -1 ? 'icon-expand-more' : 'icon-expand-less' }`}
                    id= {data.id} onClick={this.toggleHeight.bind(this)}></span>
                }
                <label>
                    <div className={`checkbox-cnt ${action}`}>
                    <Checkbox
                        color="primary"
                        inputProps={{ 'aria-label': 'secondary checkbox' }}
                        onClick= {this.onCheckboxClick.bind(this)}
                        checked= {data.isChecked ? data.isChecked : false}
                        id= {data.id}
                    />
                    </div>
                    <div className= {`checkbox_label ${action}`}>{data.name}</div>
                    
                    {data.workRequests && 
                        data.workRequests.map((workReq, key) => (
                            this.renderCheckbox(workReq, key, "noExpandIcon")
                        ))
                    }
                </label>    
            </span>
        )
    }
	
	render() {
        let outlookConfig = this.props.outlookConfig;
		if ( Object.keys(this.props).length === 0 || !outlookConfig || !outlookConfig.outlookConfig) {
			return false;
        }
        outlookConfig = outlookConfig.outlookConfig;

        const w_allPrjData = {
            id:"selectAll",
            name:  getI18NMessage( 'SelectAll' ),
            isChecked: this.state.selectAll
        }

        const w_otherPrjData = {
            id:"otherPrj",
            name: getI18NMessage( 'otherProject' ),
            isChecked: this.state.otherPrj
        }

        const OtherProjects = []
        if(outlookConfig.currentProject.length > 0) {
            OtherProjects.push(outlookConfig.currentProject[0].id)
        }
        outlookConfig.otherProjects.forEach(data => {
            OtherProjects.push(data.id)
        })
        this.totalOtherProjects = OtherProjects

        const w_status = this.state.expandCollapseStatus;

		return (
			<div className="outlookConfig-container">
                <CustomScrollbar className="outlook-body" style={{'height':'300px'}}>
                    <div className="all_project">
                        {this.renderCheckbox(w_allPrjData, undefined, "noExpandIcon")}
                    </div>
                    {outlookConfig.currentProject.length > 0 &&
                    <div className={`current_project ${outlookConfig.currentProject.length > 0 && w_status.indexOf(outlookConfig.currentProject[0].id) > -1 ? 'collapse_height' : '' }`}>
                        {
                            this.renderCheckbox(outlookConfig.currentProject[0])
                        }
                    </div>
                    }
                    {outlookConfig.otherProjects.length > 0 &&
                    <div className={`other_project ${ w_status.indexOf(w_otherPrjData.id) > -1 ? 'collapse_height' : '' }`}>
                        {this.renderCheckbox(w_otherPrjData)}
                            {
                            outlookConfig.otherProjects.map((prj, index) => (
                                <div key= {index} className={`project_list ${ w_status.indexOf(outlookConfig.otherProjects[index].id) > -1 ? 'collapse_height' : '' }`}>
                                {this.renderCheckbox(prj, index, "project" )}  
                                </div> 
                            ))
                            }
                    </div>
                    }
                </CustomScrollbar>
                <div className="outlook-footer">
                    <div className='float_right btn_panel full_height'>
                        <Button color="primary" onClick={ () => { this.props.store.dispatch(closeOutlookSettings()) } }>{ getI18NMessage("cancel") }</Button>
                        <Button variant="contained" color="primary" onClick={ this.onGenerateBtnClick.bind(this) } >
                            { getI18NMessage("generate") }
                        </Button>
                    </div>
                </div>
            </div>
		);
    }
    
    toggleHeight(event) {
        let w_status = this.state.expandCollapseStatus;
        if(w_status.indexOf(event.target.id) > -1) {
            w_status = w_status.replace(event.target.id, "")
        } else {
            w_status += event.target.id; 
        }

        this.setState({expandCollapseStatus: w_status})
    }
    
    /* istanbul ignore next */
    selectCheckbox (data, action) {
        data.forEach(element => {
            element.isChecked = action;
            if (element.workRequests) {
                this.selectCheckbox(element.workRequests, action)
            }
        });
    }

    /* istanbul ignore next */
    onCheckboxClick(event){
        event.stopPropagation();
        const outlookConfig = this.props.outlookConfig.outlookConfig
        if(event.target.id === "selectAll") {
            this.setState({selectAll:!this.state.selectAll,currentPrj:!this.state.selectAll, otherPrj:!this.state.selectAll})
            this.selectCheckbox(outlookConfig.currentProject, event.target.checked)
            this.props.updateWorkRequestData(outlookConfig)
            this.selectCheckbox(outlookConfig.otherProjects, event.target.checked)
            this.props.updateWorkRequestData(outlookConfig)
        } else if(outlookConfig.currentProject.length > 0 && event.target.id === outlookConfig.currentProject[0].id) {
            this.setState({currentPrj:!this.state.currentPrj})
            if(this.state.otherPrj && !this.state.currentPrj) {
                this.setState({selectAll: true})
            } else {
                this.setState({selectAll: false})
            }

            this.selectCheckbox(outlookConfig.currentProject, event.target.checked)
            this.props.updateWorkRequestData(outlookConfig)
        } else if(event.target.id === "otherPrj") {
            this.setState({otherPrj:!this.state.otherPrj})
            if(this.state.currentPrj && !this.state.otherPrj) {
                this.setState({selectAll: true})
            } else {
                this.setState({selectAll: false})
            }

            this.selectCheckbox(outlookConfig.otherProjects, event.target.checked)
            this.props.updateWorkRequestData(outlookConfig)
        } else {
            if ( this.totalOtherProjects.includes(event.target.id) ) {
                this.selectCheckbox(outlookConfig.otherProjects.filter(data=> data.id === event.target.id ), event.target.checked)
                this.selectCheckbox(outlookConfig.currentProject.filter(data=> data.id === event.target.id ), event.target.checked)

                this.props.updateWorkRequestData(outlookConfig)
            } else {
                outlookConfig.otherProjects.filter(prj=> {
                    return this.selectCheckbox((prj.workRequests.filter(data=>
                        data.id === event.target.id
                    )), event.target.checked)
                })
                this.selectCheckbox(outlookConfig.currentProject[0].workRequests.filter(data=> data.id === event.target.id ), event.target.checked)
                this.props.updateWorkRequestData(outlookConfig)
            }
        }
    }

    /* istanbul ignore next */
    onGenerateBtnClick() {
        const that = this;
        const config = this.props.outlookConfig.outlookConfig;

        const pluginType = this.props.store.getState().appData.appData.pluginType;
        
        let w_data = [];

        if (!this.state.selectAll) {
            const w_currentPrj = config.currentProject[0].workRequests.filter(ewr=> ewr.isChecked === true)

            if (w_currentPrj.length > 0) {
                config.currentProject[0].workRequests = w_currentPrj
                w_data =  w_data.concat(config.currentProject)
            }

            const w_newOtherPrj = []

            config.otherProjects.forEach((workreq, index) => {
                const w_otherPrj = workreq.workRequests.filter(ewr=> ewr.isChecked === true)
                if(w_otherPrj.length > 0) {
                    config.otherProjects[index].workRequests = w_otherPrj
                    w_newOtherPrj.push(config.otherProjects[index])
                }
            })

            w_data =  w_data.concat(w_newOtherPrj);
        } else {
            let w_userId = AppHelper.getParamData('sologinid');

            if (!w_userId) {
                w_userId =  AppHelper.getParamData("soexturid")
            }

            const w_url = properties.url + APP_URL_CONSTANTS.GET_ALL_WORK_REQUESTS + "/{enterpriseId}/{loginId}";
            const w_authUrl =  properties.url + "login";
            const w_allPrjData = {
                name: "allProjects",
                WorkRequestsUrl: w_url,
                tokenUrl: w_authUrl,
                enterpriseId: AppHelper.getParamData('icentid'),
                loginId: w_userId,
                sourceType: AppHelper.getAppData('enterpriseType')
            }

            w_data.push(w_allPrjData)
        }

        if (w_data.length === 0) {
            this.props.store.dispatch( showMessage({
                type: BOARD_MESSAGE_CONSTANT.TYPE_WARNING,
                message: getI18NMessage( 'minWorkRequestSelectionAlert' )
            }) );

            return;
        }

        const key = CryptoJS.enc.Utf8.parse(GLOBAL_CONSTANTS.CRYPTO_JS_KEY);  
        const iv = CryptoJS.enc.Utf8.parse(GLOBAL_CONSTANTS.CRYPTO_IV);  

        const ciphertext = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(JSON.stringify(w_data)), key,  
        {  
            keySize: 128 / 8,  
            mode: CryptoJS.mode.CBC,  
            padding: CryptoJS.pad.Pkcs7,
            iv
        }); 

        const zip = new JSZip();
        zip.file("workRequestConfig.ewr", ciphertext.toString());

        const outlookPluginLoadPath = AppUtil.processURLForAppContextPath("outlookPlugin/OutlookAddinInstaller.exe");

        JSZipUtils.getBinaryContent(outlookPluginLoadPath, function (err, data) {
            if (err) {
               throw err; 
            }

            if (pluginType === "outlook_windows") {
                zip.file("OutlookAddinInstaller.exe", data, {binary:true});
            }

            zip.generateAsync({type:"blob"}).then( content => {
                saveAs(content, "ExternalWorkRequestOutlookAddin.zip");
                that.props.store.dispatch(closeOutlookSettings())
            });
         });
    }
}

export default OutlookConfigView;